module.exports = __webpack_public_path__ + "security-circle.1cS8AZfT.svg";